<template>
  <panel title="Paczki płatności">
    <w-table
      entity-type="payment_pack"
      :per-page="-1"
      :hide-add-button="true"
      :hide-search-input="true"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      @view="goToPayments"
    />
  </panel>
</template>

<script>
import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { Errors } from '@/enums/errors.enum';
import { PaymentStateTranslations } from '@/enums/paymentState';
import { PaymentTypeTranslations } from '@/enums/paymentType';
import { date, dateTime } from '@/filters/date';
import { listMixin } from '@/mixins/list';
import { VIEW_ACTION } from '@/utils/constants';
import { preparePaymentPackQuery } from '@/utils/preparePaymentPackQuery';
import { formatAmount } from '@/utils/tables';

const messages = {
  listError: Errors.PAYMENT_PACK_CANNOT_LIST
};

// @vuese
// Lista paczek płatności
// @group Procedure
export default {
  components: { Panel, WTable },

  mixins: [listMixin('paymentPack', messages)],

  data() {
    return {
      actions: [{ ...VIEW_ACTION, permissions: ['PAYMENT.LIST'] }],
      columns: [
        { name: 'id', displayName: 'ID', sortable: true },
        { name: 'number', displayName: 'Numer', sortable: true },
        { name: 'created', displayName: 'Data utworzenia', nameTransformer: value => dateTime(value), sortable: true },
        {
          name: 'date',
          displayName: 'Termin płatności',
          nameTransformer: value => (value && date(value)) || '',
          sortable: true
        },
        {
          cssClass: 'text-right',
          displayName: 'Kwota paczki',
          name: 'total',
          nameTransformer: formatAmount,
          sortable: true
        },
        { name: 'externalId', displayName: 'ID KSAT', sortable: true },
        {
          name: 'systemNumbers',
          displayName: 'ID MDOK',
          nameTransformer: value => (value && (value.mdokId || value.mdokJoId)) || ''
        },
        {
          name: 'status',
          displayName: 'Status',
          sortable: true,
          nameTransformer: value => PaymentStateTranslations[value] || 'Nieznany status'
        },
        {
          name: 'type',
          displayName: 'Typ',
          nameTransformer: value => PaymentTypeTranslations[value] || 'Nieznany typ'
        },
        { name: 'structure.name', displayName: 'Jednostka', nameTransformer: value => value || 'OW' }
      ]
    };
  },

  methods: {
    // @vuese
    // Przechodzi do listy płatności danej paczki
    goToPayments(pack) {
      this.$router.push({ name: 'procedurePayments', params: { packId: pack.id } });
    },
    // @vuese
    // Filtry listy
    getFilters(route) {
      return preparePaymentPackQuery(route);
    }
  }
};
</script>
